import { render, staticRenderFns } from "./FormAlignmentLineLoggedIn.vue?vue&type=template&id=4bb6cef5&scoped=true&"
import script from "./FormAlignmentLineLoggedIn.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentLineLoggedIn.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentLineLoggedIn.vue?vue&type=style&index=0&id=4bb6cef5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6cef5",
  null
  
)

export default component.exports